import * as constants from 'helper/constants';
import React, { PureComponent } from 'react';
import removeUrlParameter from 'helper/helper';
import PropTypes from 'prop-types';
import strings from 'helper/localization/localization';

import MockAPI from 'helper/mockApi'; // for prop-types
import API from '../../api/api'; // for prop-types

export default class DeleteAccount extends PureComponent {
  constructor(props) {
    super(props);

    // Properties
    this.api = this.props.api;
    this.updateUser = this.props.updateUser;
    this.logoutUser = this.props.logoutUser;
    this.enteredFromWHT = this.props.enteredFromWHT;
    this.backToProfileLink = this.props.backToProfileLink;

    // State
    this.state = {
      initialScreenConfirmed: false,
      deletedAccount: false,
    };

    // Bindings
    this.initialScreenConfirm = this.initialScreenConfirm.bind(this);
    this.deleteAccount = this.deleteAccount.bind(this);
    this.resetUser = this.resetUser.bind(this);
  }

  initialScreenConfirm() {
    this.setState({ initialScreenConfirmed: true });
  }

  deleteAccount() {
    this.api.deleteUser((api) => {
      if (api.status === constants.api.success) {
        if (this.enteredFromWHT) {
          // Redirect back to WHT/AHT post-deletion
          const cleanURL = removeUrlParameter(this.backToProfileLink, 'token');
          window.location.href = cleanURL;
        } else {
          this.user = null;
          this.updateUser(null);
          this.setState({ deletedAccount: true });
        }
      }
    });
  }

  resetUser() {
    // Redirect to home page without any params,
    // resetting everything.
    window.location.href = '/';
  }

  render() {
    const initialScreen = (
      <div>
        <div className="modal-body">
          <p>{strings.discardData}</p>
          <p>{strings.deletingRemovesAccess}</p>
          <ul>
            <li>{strings.allHearingTestResults}</li>
            <li>{strings.personalizedSoundProfile}</li>
          </ul>
        </div>
        <div className="modal-footer">
          <div className="container">
            <div className="row">
              <button type="button" id="deletion-cancel--1" className="btn btn-outline-primary btn-lg btn-block" data-dismiss="modal">
                {strings.deleteAccountNo}
              </button>
            </div>
            <div className="row">
              <button type="button" className="btn btn-outline-danger mt-3 btn-lg btn-block" onClick={this.initialScreenConfirm} id="deletion-confirm--1">
                {strings.deleteAccountYes}
              </button>
            </div>
          </div>
        </div>
      </div>
    );

    const confirmationScreen = (
      <div>
        <div className="modal-body">
          <p id="deletion--are-you-sure">{strings.areYouSure}</p>
          <p>{strings.ifYouDelete}</p>
        </div>
        <div className="modal-footer d-block">
          <button type="button" className="btn btn-outline-primary btn-block" data-dismiss="modal">
            {strings.noCancel}
          </button>
          <button type="button" className="btn btn-danger btn-block" onClick={this.deleteAccount} id="deletion-confirm--2">
            {strings.yesDelete}
          </button>
        </div>
      </div>
    );

    const deletedScreen = (
      <div>
        <div className="modal-body">
          <p id="deletion--sorry">{strings.sorryToSeeYouGo}</p>
          <p>{strings.accountDeleted}</p>
        </div>
        <div className="modal-footer">
          <button type="button" id="deleted--close" className="btn btn-primary" onClick={this.resetUser} data-dismiss="modal">
            {strings.close}
          </button>
        </div>
      </div>
    );

    let modalBody;

    if (this.state.deletedAccount) {
      modalBody = deletedScreen;
    } else if (this.state.initialScreenConfirmed) {
      modalBody = confirmationScreen;
    } else {
      modalBody = initialScreen;
    }

    return (
      <div className="modal fade" id="deleteAccountModal" tabIndex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="delete-account--title">{strings.deleteMyAccount}</h5>
              <button type="button" className="close" data-dismiss="modal">
                <span aria-hidden="true">{'\u00D7'}</span>
              </button>
            </div>
            { modalBody }
          </div>
        </div>
      </div>
    );
  }
}

DeleteAccount.propTypes = {
  /** api object used for deletion */
  api: PropTypes.oneOfType([
    PropTypes.instanceOf(API),
    PropTypes.instanceOf(MockAPI),
  ]).isRequired,
  /** api call to update user object to NULL after deletion */
  updateUser: PropTypes.func.isRequired,
  enteredFromWHT: PropTypes.bool,
};

DeleteAccount.defaultProps = {
  enteredFromWHT: false,
};



// WEBPACK FOOTER //
// ./src/modules/accountManagement/DeleteAccount.jsx